import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './index.module.css';

export interface IComponentProps {
  className?: string;
}

export default function AgentEntry(props: IComponentProps) {
  const [neverClosedHint, setNeverClosedHint] = useState<boolean>(
    (localStorage.getItem('agentEntry:neverClosedHint') || 'true') === 'true'
  );

  useEffect(() => {
    setNeverClosedHint(neverClosedHint);
    localStorage.setItem(
      'agentEntry:neverClosedHint',
      neverClosedHint.toString()
    );
  }, [neverClosedHint]);
  const onEntryClick = () => {
    window.open('/agent');
  };
  return (
    <div
      className={`${styles.agentEntry} ` + props.className || ''}
      onClick={() => onEntryClick()}
    >
      <img className={styles.icon} src="/media/images/agent.png" alt="" />
      <div className={styles.label}>DeepSeek</div>
      <div
        className={`${styles.popup} ${neverClosedHint ? styles.active : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <span className={styles.text}>
          我是DeepSeek, 全天在线
          <br />
          有任何问题都可以找我~
        </span>
        {neverClosedHint ? (
          <button
            className={styles.closeBtn}
            onClick={() => setNeverClosedHint(false)}
          ></button>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
